
import {merge as observableMerge,  Observable ,  BehaviorSubject } from 'rxjs';

import {map} from 'rxjs/operators';
import { PacketDetails } from './../../shared/configuration.model';

import {
  Component, ViewChild,
  Input,
  OnInit,
  OnChanges, SimpleChanges, SimpleChange, ElementRef
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { MatDialog, MatPaginator, MatSort } from '@angular/material';
import { MatSnackBar } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MyDialogComponent } from './../my-dialog/my-dialog.component';
import { CreatePackageDialogComponent } from './../create-package-dialog/create-package-dialog.component';
import { InfodialogComponent } from './../../dialogs/infodialog/infodialog.component';




import { ConfigurationService } from '../../shared/configuration.service';
import { Configuration } from '../../shared/configuration.model';
import { isNullOrUndefined } from 'util';
import { AuthenticationService } from '../../shared/authentication.service';

@Component({
  selector: 'app-create-package',
  templateUrl: './create-package.component.html',
  styleUrls: ['./create-package.component.scss']
})
export class CreatePackageComponent implements OnInit {

  displayedColumns = ['source', 'sourcevalue', 'sourcevaluecount', 'sourcetype', 'links'];
  exampleDatabase = new ExampleDatabase();
  selection = new SelectionModel<string>(true, []);
  dataSource: ExampleDataSource | null;
  screen = false;
  dialogResult = "";
  createdPacket: PacketDetails;


  @ViewChild(MatSort) sort: MatSort;

  public foundConfigs: Configuration[] = [];

  public packageName: string;

  public buttonDisabled: boolean;





  constructor(public dialog: MatDialog, public service: ConfigurationService, public router: Router, public snackBar: MatSnackBar, public auth: AuthenticationService) { }

  ngOnInit() {

    this.buttonDisabled = true;
    this.dataSource = new ExampleDataSource(this.exampleDatabase, this.sort);

  }




  deleteRow(QualityAttribute, QualityAttributeValue, QualityAttributeCount) {
    for (let i = 0; i <= this.exampleDatabase.data.length; i++) {
      if (this.exampleDatabase.data[i].GCAttribute == QualityAttribute && this.exampleDatabase.data[i].GCAttributeValue == QualityAttributeValue &&
        this.exampleDatabase.data[i].GCAttributeCount == QualityAttributeCount) {
        this.exampleDatabase.data.splice(i, 1);
        break;
      }
    }
    this.dataSource = new ExampleDataSource(this.exampleDatabase, this.sort);
  }

  addRow(result) {
    if (result.sourcevaluepriority === null || result.sourcevaluepriority === '') {
      result.sourcevaluepriority = 0;
    }
    if (this.exampleDatabase.data.length == 0) {
      this.exampleDatabase.data.push({
        PacketID: result.id, GCAttribute: result.source, GCAttributeValue: result.sourcevalue,
        GCAttributeCount: result.sourcevaluecount, GCSourceType: result.configurationtype
      });
      this.dataSource = new ExampleDataSource(this.exampleDatabase, this.sort);
      return;
    }
    if (result.sourcevaluepriority === 0) {
      this.exampleDatabase.data.push({
        PacketID: result.id, GCAttribute: result.source, GCAttributeValue: result.sourcevalue,
        GCAttributeCount: result.sourcevaluecount, GCSourceType: result.configurationtype
      });
      this.dataSource = new ExampleDataSource(this.exampleDatabase, this.sort);
      return;
    }

    if (this.checkData(this.exampleDatabase.data, result)) {
      this.exampleDatabase.data.push({
        PacketID: result.id, GCAttribute: result.source, GCAttributeValue: result.sourcevalue,
        GCAttributeCount: result.sourcevaluecount, GCSourceType: result.configurationtype
      });
      this.dataSource = new ExampleDataSource(this.exampleDatabase, this.sort);
    }
    else {
      return;
    }



  }


  checkData(data: Configuration[], result): Boolean {
    for (var i = 0, len = data.length; i < len; i++) {
      if (data[i].GCAttributeValue === result.sourcevalue) {
        let dialogRef = this.dialog.open(InfodialogComponent, {
          width: '600px',
          data: {
            title: 'Alert',
            content: 'Configuration can not be added for same QualityAttributeValue '
          }
        });
        break;
      } else {
        return true;
      }
    }
    return false;

  }




  openDialog() {
    let dialogRef = this.dialog.open(MyDialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Cancel') {
        return;
      }
      else {
        this.addRow(result);
      }
    })
  }

  openSaveDialog() {
    let dialogRef = this.dialog.open(CreatePackageDialogComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.screen = true;
      if (result === 'Cancel') {
        this.screen = false;
      }
      else {
        this.onClick(result);
      }
    })
  }


  onClick(result): void {
    this.service.createPackage(result.packageName, result.packetTypeName, result.packetQueueCategory, result.priority, this.exampleDatabase.data, this.auth.currentState).subscribe(res => {
      if (res.ID === 0) {
        let infoDialogPacketError = this.dialog.open(InfodialogComponent, {
          width: '500px',
          data: {
            title: 'Packet Creation Error',
            content: 'Packet with same priority already exist.'
          }
        });
        this.screen = false;
      }
      else {
        this.createdPacket = res;
        this.router.navigate(["package/" + this.createdPacket.ID]);
        this.showSnackbarMessage('Packet created.');
        this.screen = false;
      }
    });
  }
  showSnackbarMessage(message: string) {
    this.snackBar.open(message, '', {
      duration: 2000
    });
  }
}


/** An example database that the data source uses to retrieve data for the table. */
export class ExampleDatabase {
  /** Stream that emits whenever the data has been modified. */
  dataChange: BehaviorSubject<Configuration[]> = new BehaviorSubject<Configuration[]>([]);
  get data(): Configuration[] { return this.dataChange.value; }

  constructor() {
    // Fill up the database with 100 users.
    this.addUser();
  }

  /** Adds a new user to the database. */
  addUser() {
    ;

    const copiedData = [];
    this.dataChange.next(copiedData);
  }

}

/**
 * Data source to provide what data should be rendered in the table. Note that the data source
 * can retrieve its data in any way. In this case, the data source is provided a reference
 * to a common data base, ExampleDatabase. It is not the data source's responsibility to manage
 * the underlying data. Instead, it only needs to take the data and send the table exactly what
 * should be rendered.
 */
export class ExampleDataSource extends DataSource<any> {
  constructor(private _exampleDatabase: ExampleDatabase, private _sort: MatSort) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Configuration[]> {
    const displayDataChanges = [
      this._exampleDatabase.dataChange,
      this._sort.sortChange,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      return this.sortData();
    }));
  }

  disconnect() { }


  /** Returns a sorted copy of the database data. */
  sortData(): Configuration[] {
    const data = this._exampleDatabase.data.slice();
    if (!this._sort.active || this._sort.direction == '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'source': [propertyA, propertyB] = [a.GCAttribute, b.GCAttribute]; break;
        case 'sourcevalue': [propertyA, propertyB] = [a.GCAttributeValue, b.GCAttributeValue]; break;
        case 'sourcevaluecount': [propertyA, propertyB] = [a.GCAttributeCount, b.GCAttributeCount]; break;
      }

      let valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      let valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction == 'asc' ? 1 : -1);
    });
  }
}